import { useUnits } from './Units';

export default function SizeUnitLabel({ className }) {
  const { units } = useUnits();

  return <span className={className}>{units === 'in' ? 'inches' : 'cm'}</span>;
}
